import { Rokojori } from "../../../js/Rokojori";
import { ClassInfo } from "../../../templates/code-doc/ClassInfo";
import { CodeInfo } from "../../code-doc/CodeInfo";
import { MemberInfo } from "../../code-doc/MemberInfo";
import { GodotInspector } from "./GodotInspector";

export class GodotInspectorViewCreator
{
  static fromDoc( e:Element )
  {
    let className = ClassInfo.className.query( e ).textContent;
    let inspector = GodotInspector.type.create();
    
    inspector.appendChild( 
      GodotInspector.classRegion.create( className )
    );
    
    let members = MemberInfo.type.queryAll( e ).filter(
       m => MemberInfo.exportedMember.in( m ) || 
            MemberInfo.dataType.query( m ) && MemberInfo.dataType.query( m ).textContent.indexOf( "Callable" ) != -1
    );

    let memberLines:string[] = [];

    let uiImageGroups = 
    {
      "width":"Size & Margins",
      "position":"Position",
      "pivotX":"Rotation & Scale",
      "modulationColor":"Modulation"
    }

    for ( let i = 0; i < members.length; i++ )
    { 
      let m = members[ i ];
      let name = MemberInfo.memberName.query( m ).textContent;
      let type = MemberInfo.dataType.query( m ).textContent;
      let attributes = MemberInfo.memberAttribute.queryAll( m );

      let exportGroup = attributes.find( a => MemberInfo.memberAttributeValue.from( a ) == "ExportGroup" );

      if ( exportGroup || ( className == "UIImage" && uiImageGroups[ name ] ) )
      {
        let exportGroupName = "";

        if ( exportGroup )
        {
          exportGroupName = MemberInfo.memberAttributeParameters.from( exportGroup );
        }
        else
        {
          exportGroupName = uiImageGroups[ name ];
        } 

        memberLines.push( `@ExportGroup "${exportGroupName}"`);
      }

      let memberLine = name + ":" + type;

      if ( type.indexOf( "Callable" ) != -1 )
      {
        let buttonLabel = CodeInfo.getEditorScriptName( name.replace( /button$/i, "") );
        memberLine = `@ToolButton "${buttonLabel}"`;
      }

      memberLines.push( memberLine );
    }

    let memberRegion = GodotInspector.memberRegion.create( );
    let memberLinesData = memberLines.join( "\n" );

    console.log( "memberLinesData", "\n" + memberLinesData );
    memberRegion.innerHTML = memberLinesData;

    inspector.appendChild( memberRegion );

    Rokojori.$.processRawTemplateElement( inspector );
    GodotInspector.applyOnElement( inspector );

    return inspector;

  }
}